export function fillData(data) {
  const tarLen = 10
  const dataLen = data.length
  const needFill = tarLen - dataLen

  for (let i = 0; i < needFill; i++) {
    data.push({ hidden: true })
  }
}
